// akitarosewater.ca için özel js kodları

// alert('akitarosewater.ca');

"use strict";

import './Filtered'



// initial
var Init = function () {

    var Load = function () {
        console.log('Powered By Akita Rosewater - osman.yavuz@akita.com.tr');

        
    }

    return {
        init: function () {
            Load();
        },
    };

}();


$(function () {

    Init.init();

});